/**
 * The app-wide TanStack Query client, in its own module so NON-component
 * code (the auth store) can reach it.
 *
 * Why: several query keys (fullPlayerPool, cheatsheet, …) cache TIER-GATED
 * data with no user component in the key, and some have multi-hour
 * staleTimes. Without an explicit clear on login/logout, rows fetched in
 * one auth state survive into the next — a premium user could keep seeing
 * the 10-player free pool for the rest of the tab session (owner hit
 * exactly this). auth.ts calls `queryClient.clear()` on every auth
 * transition so all server state refetches under the new identity.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep data fresh-ish but avoid hammering the API on every focus.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
      // ALWAYS attempt fetches and surface real errors. The default
      // ('online') PAUSES queries whenever navigator.onLine reads false:
      // status stays pending forever, isLoading and isError both read
      // false, and every screen falls through to its empty state -
      // offline read as "Rankings are warming up" and, worse, "Draft not
      // found" for the user's own draft (audit finding; reproduced live).
      // 'offlineFirst' was not enough - RETRIES still pause on the flaky
      // onLine flag (WKWebView misreports it). 'always' = never pause:
      // a dead network fails fast into the visible error + Retry states
      // every screen already has.
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
});
